<div class="class-wrapper">
  <app-status-messages
    [msgs]="msgs"
    [btnLabel]="btnLabel"
    [continueType]="continueType"
    (targetAction)="handleIncomingAction($event)"
  ></app-status-messages>
  <div class="modal-header text-center">
    <h4 class="modal-title w-100 font-weight-bold">{{ mode }} Persona</h4>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="managePersonaModal.hide()"
      id="close-modal-icon"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body m-3 p-0">
    <div class="row flex-add-form">
      <form
        class="text-center border border-light p-5 edit-form w-100"
        [formGroup]="personaForm"
        (ngSubmit)="managePersona()"
        autocomplete="off"
      >
        <div class="md-form mb-5 form-group">
          <input
            type="text"
            id="persona_name"
            formControlName="persona_name"
            class="form-control"
            mdbInput
          />
          <label for="persona_name">Persona Name</label>
        </div>
        <div class="md-form mb-5 form-group">
          <input
            type="text"
            id="persona_description"
            formControlName="persona_description"
            class="form-control"
            mdbInput
          />
          <label for="persona_description">Persona Description</label>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button
      mdbBtn
      class="waves-light theme-action-button"
      mdbWavesEffect
      (click)="managePersonaModal.hide()"
      id="close-modal-btn"
    >
      Close
    </button>
    <button
      mdbBtn
      class="waves-light theme-action-button"
      mdbWavesEffect
      (click)="managePersona()"
      id="action-persona-btn"
    >
      {{ mode }} Persona
    </button>
  </div>
</div>
